import { formatPrice } from './format';
import { getBrandNameFromBrandId } from './brands';

const getListByFilter = (list, filter) => {
    let filteredList = list;
    switch (filter) {
        case 'Vendas':
            filteredList = list
                .filter(
                    order =>
                        order.status_evento !== 'CANCELADO' &&
                        order.status !== 'CANCELADO'
                )
                .filter(order => order.channel !== 'DEVOLUCAO');
            break;
        case 'Devoluções':
            filteredList = list.filter(order => order.channel === 'DEVOLUCAO');
            break;
        case 'Cancelamentos':
            filteredList = list.filter(
                order =>
                    order.status_evento === 'CANCELADO' ||
                    order.status === 'CANCELADO'
            );
            break;
        default:
            filteredList = list;
            break;
    }
    return filteredList;
};

const applySearchFilter = (list, search) => {
    const formattedSearch = search.toLowerCase().trim();

    const newFilteredOrders = list.filter(order => {
        const orderId = order?.orderId || '';
        const clientName = order?.clientData?.nome || '';
        const formattedOrderId = orderId.toLowerCase();
        const formattedClientName = clientName.toLowerCase();
        return (
            formattedOrderId.includes(formattedSearch) ||
            formattedClientName.includes(formattedSearch)
        );
    });

    return newFilteredOrders;
};

const applyBrandFilter = (list, brand) => {
    const defaultBrands = ['allBrands', 'myBrands', 'otherBrands'];
   if (!brand || defaultBrands.includes(brand)) return list;
   return list.filter(
       order => getBrandNameFromBrandId(order.brandId) === brand
   );
};

const getTotalValue = (orders, filter) => {
    if (!orders?.length) return formatPrice(0);

    if (filter === 'Joias') {
        const total = orders
            .filter(order => order.colecao?.includes('JOIAS'))
            .reduce((sum, order) => sum + Number(order.jewelValueItem || 0), 0);
        return formatPrice(total);
    }

    if (filter === 'Online') {
        const total = orders
            .filter(order => ['ONLINE', 'DEVOLUCAO'].includes(order.channel))
            .reduce((sum, order) => sum + Number(order.valueAsNumber || 0), 0);
        return formatPrice(total);
    }

    const total = orders.reduce(
        (sum, order) => sum + Number(order.valueAsNumber || 0),
        0
    );
    return formatPrice(total);
};

const applyOrdersFilter = (list, filter) => {
    if (!filter || filter === 'allOrders') return list;

    if (filter === 'Box') {
        return list.filter(order =>
            ['SOMASTORE', 'ESTOQUE PROPRIO'].includes(
                order.channel?.toUpperCase()
            )
        );
    }

    if (filter === 'Linx') {
        return list.filter(order =>
            ['FISICO'].includes(order.channel?.toUpperCase())
        );
    }

    if (filter === 'Online') {
        return list.filter(order =>
            ['ONLINE', 'DEVOLUCAO'].includes(order.channel?.toUpperCase())
        );
    }

    if (filter === 'Vitrine') {
        return list.filter(order =>
            ['VITRINE'].includes(order.channel?.toUpperCase())
        );
    }

    if (filter === 'Joias') {
        return list.filter(order => order.colecao?.includes('JOIAS'));
    }

    if (filter === 'Vintage') {
        return list.filter(order => order.isVintage);
    }

    if (filter === 'Código atual') {
        return list.filter(order => order.vendedor);
    }

    if (filter === 'Código anterior') {
        return list.filter(
            order =>
                order.vendedor_utilizado &&
                order.vendedor_utilizado !== order.vendedor
        );
    }

    return list.filter(
        order => order.channel.toUpperCase() === filter.toUpperCase()
    );
};

const getCartsListByFilter = (carts, filter) => {
    let filteredCartsList = carts;

    switch (filter) {
        case 'Todos':
            filteredCartsList = carts;
            break;
        case 'Pendentes':
            filteredCartsList = carts?.filter(
                cart => cart?.status === 'PENDENTE'
            );
            break;
        case 'Finalizados':
            filteredCartsList = carts?.filter(
                cart => cart?.status === 'FINALIZADO'
            );
            break;
        default:
            filteredCartsList = carts;
            break;
    }

    return filteredCartsList;
};

export {
    getListByFilter,
    applySearchFilter,
    applyBrandFilter,
    getTotalValue,
    applyOrdersFilter,
    getCartsListByFilter,
};
